import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 15H6.66667V13.3333H2.5V15ZM2.5 5V6.66667H11.6667V5H2.5ZM2.5 10.8333H9.16667V9.16667H2.5V10.8333Z"
        fill="#6929C4"
      />
      <path
        d="M17.5007 13.3334H15.0007V3.33337H13.334V13.3334H10.834L14.1673 16.6667L17.5007 13.3334Z"
        fill="#6929C4"
      />
    </svg>
  ),
  'SortDescending',
  '0 0 24 24'
);
